import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import DropdownUser from "./DropdownUser";

import { IoReorderThreeOutline } from "react-icons/io5";

import { ROLES } from "../../uitls/Utils";

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const path = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const editId = searchParams.get("id");

  const getPageTitle = () => {
    const routeTitles = {
      "/admin/dashboard": "Admin Dashboard",
      "/admin/employee": "Employee Management",
      "/admin/template": "Template Management",
      "/admin/assign-template": "Assign Appraisal",
      "/admin/assign-template/add-update": "Assign Appraisal",
      "/admin/create-appraisal": "Create Appraisal",
      "/admin/template/add-update": "Create Template",
      "/admin/business-unit": "Business Units Management",
      "/admin/job-title": "Job Titles Management",
      "/admin/all-appraisals": "All Appraisals",
      "/admin/review-final-appraisal": "Review Appraisal",

      "/mgr/dashboard": "Manager Dashboard",
      "/mgr/all-appraisals": "Manager Appraisals",
      "/mgr/view-appraisals": "View Appraisals",
      "/mgr/update-appraisals": "Update Appraisals",
      "/mgr/review-appraisals": "Review Appraisals",
      "/mgr/self-appraisals": "Self Appraisals",
      "/mgr/employee-appraisals": "Employee Appraisals",
      "/mgr/employee": "Employee Management",
      "/mgr/reviewed-appraisals": "Reviewed Appraisals",
      "/mgr/view-appraisal": "Review Appraisal",
      "/mgr/create-appraisal": "Review Employee Appraisal",
      "/mgr/manage-manager-self-appraisal": "Self Appraisal",
      "/mgr/manager-self-appraisal": "Self Appraisal",

      "/hr/dashboard": "HR Dashboard",
      "/hr/create-appraisal": "Create Appraisal",
      "/hr/view-appraisal": "View Appraisal",

      "/emp/dashboard": "Employee Dashboard",
      "/emp/self-appraisal":"Self Appraisal",
      "/emp/performance": "Employee Performance",
      "/emp/profile": "Employee Profile",
      "/emp/create-appraisal": "Performance Self-Evaluation",
      "/emp/view-appraisal": "View Appraisal",
      "/user-profile": "My Profile",
      "/user-password": "Change Password",
    };

    if (path === "/admin/employee/add-update") {
      return editId ? "Update Employee" : "Add Employee";
    }

    return routeTitles[path] || "Page Title";
  };

  const getPageSubtitle = () => {
    const routeSubtitles = {
      "/admin/dashboard": "Welcome back! Here's what's happening in your organization.",
      "/admin/employee": "Manage employee information and details",
      "/admin/employee/add-update": editId
        ? "Update employee information and details"
        : "Add a new employee to the organization",
      "/admin/template": "Create and manage appraisal templates for performance evaluations",
      "/admin/template/add-update": editId
        ? "Update existing appraisal template"
        : "Create new appraisal template with custom questions",
      "/admin/assign-template": "Assign appraisal templates to employees and manage assignments",
      "/admin/assign-template/add-update": editId
        ? "Update appraisal assignment details"
        : "Configure and assign performance appraisals to employees",
      "/admin/business-unit": "Manage and organize business units and departments",
      "/admin/job-title": "Manage and organize job titles across your organization",
      "/admin/create-appraisal": "Create new performance appraisal for employee evaluation",
      "/admin/all-appraisals": "View and manage all performance appraisals across the organization",
      "/admin/review-final-appraisal": "Review and finalize employee performance appraisals",
      "/mgr/dashboard": "Welcome back! Manage your team's performance and appraisals.",
      "/mgr/all-appraisals": "View and manage appraisals for your team members",
      "/mgr/view-appraisals": "View detailed appraisal information for employees",
      "/mgr/update-appraisals": "Update and modify employee appraisal details",
      "/mgr/review-appraisals": "Review and evaluate employee performance appraisals",
      "/mgr/self-appraisals": "Manage your own performance self-appraisal",
      "/mgr/employee-appraisals": "View and manage employee appraisals in your team",
      "/mgr/reviewed-appraisals": "View completed and reviewed appraisals",
      "/mgr/create-appraisal": "Review employee's submitted appraisal and provide your feedback",
      "/mgr/manage-manager-self-appraisal": "Complete and manage your self-performance evaluation",
      "/mgr/manager-self-appraisal": "Your personal performance self-assessment",
      "/mgr/employee": "Manage team members and their information",
      "/mgr/view-appraisal": "Review employee appraisals and provide feedback",
      "/hr/dashboard": "Welcome back! Oversee HR operations and employee management.",
      "/hr/create-appraisal": "Create and initiate performance appraisal processes",
      "/hr/view-appraisal": "View and monitor appraisal progress across departments",
      "/emp/dashboard": "Welcome back! Track your performance and development.",
      "/emp/performance": "Track your performance metrics and achievements",
      "/emp/create-appraisal": "Complete your performance self-evaluation and assessment",
      "/emp/profile": "View and manage your employee profile",
      "/emp/view-appraisal": "View your performance appraisal results and feedback",
      "/user-profile": "Manage your personal profile information",
      "/user-password": "Change your account password",
    };

    return routeSubtitles[path] || "";
  };

  const userRole = localStorage.getItem("roleId");
  const pageTitle = getPageTitle();
  const pageSubtitle = getPageSubtitle();

  return (
    <header className="sticky top-0 z-99 flex w-full brand-header relative overflow-hidden shadow-lg border-b border-white/10">
      <div className="relative flex flex-grow items-center justify-between px-4 py-4 sm:px-5 sm:py-5 md:px-6 md:py-6 2xl:px-11">
        <div className="flex items-center gap-x-3 sm:gap-x-4 min-w-0 flex-1">
          <div className="flex items-center gap-2 sm:gap-4 lg:hidden flex-shrink-0">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                setSidebarOpen(!sidebarOpen);
              }}
              className="z-99999 block rounded-xl border border-white/30 bg-white/10 backdrop-blur-md shadow-lg hover:bg-white/20 hover:shadow-xl transition-all duration-300 lg:hidden p-1.5 sm:p-2 flex-shrink-0 hover:scale-105"
            >
              <IoReorderThreeOutline className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </button>

            <Link
              className="block flex-shrink-0 lg:hidden transition-transform duration-300 hover:scale-105"
              to={`/${Object.keys(ROLES).find(
                (key) => ROLES[key] === userRole
              )}/dashboard`}
            >
              <img
                src={"/images/amp.png"}
                alt="Logo"
                className="h-6 w-auto sm:h-8 drop-shadow-lg"
              />
            </Link>
          </div>

          {/* Enhanced Page Title Section */}
          <div className="min-w-0 flex-1 lg:flex-none">
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-3xl font-bold text-white truncate leading-tight drop-shadow-lg tracking-tight">
              {pageTitle}
            </h1>
            {pageSubtitle && (
              <p className="text-xs sm:text-sm md:text-base text-blue-50/90 mt-1.5 hidden sm:block leading-relaxed max-w-2xl font-medium drop-shadow-md">
                {pageSubtitle}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3 2xsm:gap-7 relative z-10" style={{ overflow: 'visible' }}>
          <DropdownUser />
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  setSidebarOpen: PropTypes.func.isRequired,
};

export default Header;
